export const coursesData = {
  kitesurf: [
    {
      id: "beginner-kitesurf",
      name: {
        en: "Beginner Kitesurfing",
        es: "Kitesurf para Principiantes",
        de: "Anfänger Kitesurfen",
        fr: "Kitesurf Débutant"
      },
      type: "group",
      maxStudents: 4,
      description: {
        en: "Group lessons (Max 4 students) - Learn from first piloting to first waterstart",
        es: "Lecciones grupales (Máx 4 estudiantes) - Aprende desde el primer pilotaje hasta el primer waterstart",
        de: "Gruppenunterricht (Max 4 Schüler) - Vom ersten Pilotieren bis zum ersten Wasserstart",
        fr: "Cours en groupe (Max 4 élèves) - Du premier pilotage au premier waterstart"
      },
      highlights: {
        en: ["Equipment rental", "IKO Level 1 & 2", "Safety certification", "IKO certification"],
        es: ["Alquiler de equipo", "IKO Nivel 1 y 2", "Certificación de seguridad", "Certificación IKO"],
        de: ["Ausrüstungsverleih", "IKO Level 1 & 2", "Sicherheitszertifikat", "IKO-Zertifizierung"],
        fr: ["Location d'équipement", "IKO Niveau 1 & 2", "Certification sécurité", "Certification IKO"]
      },
      pricing: [
        { hours: 6, price: 260 },
        { hours: 8, price: 320 },
        { hours: 10, price: 380 },
        { hours: 12, price: 450 }
      ]
    },
    {
      id: "intermediate-kitesurf",
      name: {
        en: "Intermediate Kiteboarding",
        es: "Kiteboarding Intermedio",
        de: "Fortgeschrittenes Kiteboarding",
        fr: "Kitesurf Intermédiaire"
      },
      type: "semi-private",
      maxStudents: 2,
      description: {
        en: "Semi-private lessons (Max 2 students) - Master upwind riding and transitions",
        es: "Lecciones semi-privadas (Máx 2 estudiantes) - Domina la navegación contra el viento y transiciones",
        de: "Semi-Privatunterricht (Max 2 Schüler) - Meistere das Höhelaufen und Transitionen",
        fr: "Cours semi-privés (Max 2 élèves) - Maîtrisez la remontée au vent et les transitions"
      },
      highlights: {
        en: ["IKO Level 1, 2 & 3", "Riding upwind", "Sliding transitions", "Toe-riding", "Video analysis"],
        es: ["IKO Nivel 1, 2 y 3", "Navegación contra viento", "Transiciones deslizantes", "Toe-riding", "Análisis de video"],
        de: ["IKO Level 1, 2 & 3", "Höhelaufen", "Gleitende Transitionen", "Toe-Riding", "Videoanalyse"],
        fr: ["IKO Niveau 1, 2 & 3", "Remontée au vent", "Transitions glissées", "Toe-riding", "Analyse vidéo"]
      },
      pricing: [
        { hours: 4, price: 200 },
        { hours: 6, price: 300 },
        { hours: 8, price: 380 },
        { hours: 10, price: 440 }
      ]
    },
    {
      id: "private-kitesurf",
      name: {
        en: "Private Coaching - Kitesurf",
        es: "Coaching Privado - Kitesurf",
        de: "Privatcoaching - Kitesurf",
        fr: "Coaching Privé - Kitesurf"
      },
      type: "private",
      maxStudents: 1,
      description: {
        en: "One-on-one personalized training with flexible schedule",
        es: "Entrenamiento personalizado uno a uno con horario flexible",
        de: "Persönliches Einzeltraining mit flexiblem Zeitplan",
        fr: "Entraînement personnalisé en tête-à-tête avec horaire flexible"
      },
      highlights: {
        en: ["IKO Level 1-5", "Freestyle, Big air, Wave riding", "Video feedback", "Multiple spots", "Flexible schedule"],
        es: ["IKO Nivel 1-5", "Freestyle, Big air, Olas", "Retroalimentación en video", "Múltiples spots", "Horario flexible"],
        de: ["IKO Level 1-5", "Freestyle, Big Air, Wellenreiten", "Video-Feedback", "Mehrere Spots", "Flexibler Zeitplan"],
        fr: ["IKO Niveau 1-5", "Freestyle, Big air, Vagues", "Retour vidéo", "Plusieurs spots", "Horaire flexible"]
      },
      pricing: [
        { hours: 4, price: 280 },
        { hours: 6, price: 420 },
        { hours: 8, price: 500 },
        { hours: 10, price: 600 }
      ]
    }
  ],
  surf: [
    {
      id: "beginner-surf",
      name: {
        en: "Beginner Surfing",
        es: "Surf para Principiantes",
        de: "Anfänger Surfen",
        fr: "Surf Débutant"
      },
      type: "group",
      maxStudents: 4,
      description: {
        en: "Group lessons (2-4 persons) - All gear included",
        es: "Lecciones grupales (2-4 personas) - Todo el equipo incluido",
        de: "Gruppenunterricht (2-4 Personen) - Alle Ausrüstung inklusive",
        fr: "Cours en groupe (2-4 personnes) - Tout l'équipement inclus"
      },
      highlights: {
        en: ["All gear included", "Professional instructor", "Perfect for first-timers"],
        es: ["Todo el equipo incluido", "Instructor profesional", "Perfecto para principiantes"],
        de: ["Alle Ausrüstung inklusive", "Professioneller Instruktor", "Perfekt für Anfänger"],
        fr: ["Tout l'équipement inclus", "Instructeur professionnel", "Parfait pour les débutants"]
      },
      pricing: [
        { duration: "1h30", price: 35, unit: "person" },
        { duration: "3 hours", price: 65, unit: "person" }
      ]
    },
    {
      id: "private-surf",
      name: {
        en: "Private / Surf Guiding",
        es: "Privado / Guía de Surf",
        de: "Privat / Surf-Guiding",
        fr: "Privé / Guidage Surf"
      },
      type: "private",
      maxStudents: 1,
      description: {
        en: "One-on-one surf coaching - All gear included",
        es: "Coaching de surf uno a uno - Todo el equipo incluido",
        de: "Einzelcoaching Surfen - Alle Ausrüstung inklusive",
        fr: "Coaching surf en tête-à-tête - Tout l'équipement inclus"
      },
      highlights: {
        en: ["Personalized coaching", "All gear included", "Flexible spots"],
        es: ["Coaching personalizado", "Todo el equipo incluido", "Spots flexibles"],
        de: ["Persönliches Coaching", "Alle Ausrüstung inklusive", "Flexible Spots"],
        fr: ["Coaching personnalisé", "Tout l'équipement inclus", "Spots flexibles"]
      },
      pricing: [
        { duration: "1h30", price: 50, unit: "person" },
        { duration: "3 hours", price: 95, unit: "person" }
      ]
    },
    {
      id: "rental-surf",
      name: {
        en: "Rental Surfboard",
        es: "Alquiler de Tabla de Surf",
        de: "Surfboard-Verleih",
        fr: "Location Planche de Surf"
      },
      type: "rental",
      description: {
        en: "Surfboard & wetsuit rental",
        es: "Alquiler de tabla de surf y traje de neopreno",
        de: "Surfboard & Neoprenanzug Verleih",
        fr: "Location planche de surf & combinaison"
      },
      highlights: {
        en: ["Surfboard included", "Wetsuit included", "Quality equipment"],
        es: ["Tabla incluida", "Traje de neopreno incluido", "Equipo de calidad"],
        de: ["Surfboard inklusive", "Neoprenanzug inklusive", "Hochwertige Ausrüstung"],
        fr: ["Planche incluse", "Combinaison incluse", "Équipement de qualité"]
      },
      pricing: [
        { duration: "Full day", price: 35 },
        { duration: "Half day / Session", price: 25 },
        { duration: "Per day (up to 3 days)", price: 20 }
      ]
    }
  ],
  wingfoil: [
    {
      id: "semi-private-wingfoil",
      name: {
        en: "Semi-Private Lessons",
        es: "Lecciones Semi-Privadas",
        de: "Semi-Privatunterricht",
        fr: "Cours Semi-Privés"
      },
      type: "semi-private",
      maxStudents: 2,
      description: {
        en: "Semi-private wingfoil lessons (Max 2 students)",
        es: "Lecciones de wingfoil semi-privadas (Máx 2 estudiantes)",
        de: "Semi-privater Wingfoil-Unterricht (Max 2 Schüler)",
        fr: "Cours de wingfoil semi-privés (Max 2 élèves)"
      },
      highlights: {
        en: ["Max 2 students", "All equipment included", "Professional instruction"],
        es: ["Máx 2 estudiantes", "Todo el equipo incluido", "Instrucción profesional"],
        de: ["Max 2 Schüler", "Alle Ausrüstung inklusive", "Professioneller Unterricht"],
        fr: ["Max 2 élèves", "Tout l'équipement inclus", "Instruction professionnelle"]
      },
      pricing: [
        { hours: 4, price: 200 },
        { hours: 6, price: 300 },
        { hours: 8, price: 380 },
        { hours: 10, price: 440 }
      ],
      extraHour: 44
    },
    {
      id: "private-wingfoil",
      name: {
        en: "Private Lessons",
        es: "Lecciones Privadas",
        de: "Privatunterricht",
        fr: "Cours Privés"
      },
      type: "private",
      maxStudents: 1,
      description: {
        en: "Personalized private coaching with flexible schedule",
        es: "Coaching privado personalizado con horario flexible",
        de: "Personalisiertes Privatcoaching mit flexiblem Zeitplan",
        fr: "Coaching privé personnalisé avec horaire flexible"
      },
      highlights: {
        en: ["1-on-1 coaching", "Flexible schedule", "All equipment included", "Personalized progression"],
        es: ["Coaching 1 a 1", "Horario flexible", "Todo el equipo incluido", "Progresión personalizada"],
        de: ["1-zu-1 Coaching", "Flexibler Zeitplan", "Alle Ausrüstung inklusive", "Personalisierte Progression"],
        fr: ["Coaching 1-à-1", "Horaire flexible", "Tout l'équipement inclus", "Progression personnalisée"]
      },
      pricing: [
        { hours: 4, price: 280 },
        { hours: 6, price: 420 },
        { hours: 8, price: 500 },
        { hours: 10, price: 600 }
      ],
      extraHour: 60
    },
    {
      id: "rental-wingfoil",
      name: {
        en: "Rental Wingfoil",
        es: "Alquiler Wingfoil",
        de: "Wingfoil-Verleih",
        fr: "Location Wingfoil"
      },
      type: "rental",
      description: {
        en: "Complete wingfoil equipment rental",
        es: "Alquiler completo de equipo de wingfoil",
        de: "Kompletter Wingfoil-Ausrüstungsverleih",
        fr: "Location complète d'équipement wingfoil"
      },
      highlights: {
        en: ["Complete wingfoil set", "Quality equipment", "Flexible rental period"],
        es: ["Set completo de wingfoil", "Equipo de calidad", "Período de alquiler flexible"],
        de: ["Komplettes Wingfoil-Set", "Hochwertige Ausrüstung", "Flexibler Mietzeitraum"],
        fr: ["Set wingfoil complet", "Équipement de qualité", "Période de location flexible"]
      },
      pricing: [
        { duration: "3 days", price: 180 },
        { duration: "6-7 days", price: 300 }
      ]
    }
  ]
};
